import { useContext, useCallback } from 'react';
import { AjaxContext } from 'commons-ui';
import { IPredictAndWinV2Contest } from '../model';

const useService = () => {
	const { postData } = useContext(AjaxContext);

	const requestCreatePredictWinContest = useCallback((appName: string, contestDetails: IPredictAndWinV2Contest) => {
		return postData({
			endpoint: '/marketing/dashboard/predictAndWinV2/createContest',
			body: { contestDetails },
			queryParams: { appName }
		});
	}, []);

	const requestUpdatePredictWinContest = useCallback((appName: string, contestDetails: IPredictAndWinV2Contest) => {
		return postData({
			endpoint: '/marketing/dashboard/predictAndWinV2/updateContest',
			body: { contestDetails },
			queryParams: { appName }
		});
	}, []);

	return {
		requestCreatePredictWinContest,
		requestUpdatePredictWinContest
	};
};

export default useService;
